import {
  bcp47,
  createI18n,
  isLangCode,
  LANG_STORAGE_KEY,
  resolveLang,
  type LangCode,
} from '@sm/i18n';
import { initReactI18next } from 'react-i18next';

export const WEB_NAMESPACES = ['common', 'auth', 'panel', 'errors'] as const;

export function readStoredLang(): LangCode | null {
  try {
    const v = localStorage.getItem(LANG_STORAGE_KEY);
    return isLangCode(v) ? v : null;
  } catch {
    return null;
  }
}

export function storeLang(code: LangCode): void {
  try {
    localStorage.setItem(LANG_STORAGE_KEY, code);
  } catch {
    /* ignoriše se */
  }
}

export function applyHtmlLang(code: LangCode): void {
  if (typeof document !== 'undefined') document.documentElement.lang = bcp47(code);
}

const initial = resolveLang(
  readStoredLang(),
  typeof navigator !== 'undefined' ? navigator.language : null,
);

export const i18n = createI18n({
  lng: initial,
  ns: WEB_NAMESPACES,
  defaultNS: 'panel',
  use: [initReactI18next],
  options: { fallbackNS: ['common', 'panel'] },
});

applyHtmlLang(initial);
